import type { SupportedLocale } from './index';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Prefixes a path with the locale prefix.
 * EN is the default locale and has no prefix.
 */
export function localePath(path: string, locale: SupportedLocale | string): string {
  if (locale === 'en') return path;
  return `/${locale}${path}`;
}

/**
 * Hook for locale-aware path generation.
 */
export function useLocalePath() {
  const { i18n } = useTranslation();
  return useCallback(
    (path: string) => localePath(path, i18n.language),
    [i18n.language]
  );
}
